import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';
import { bannerImg01, bannerImg03 } from "../../../assets";

function Section1() {
    const slides = [
        { id: 1, image: bannerImg01, socialIcons: true },
        { id: 2, image: bannerImg03, successRate: true },
    ];

    return (
        <div className="banner2-section mb-130">
            <Swiper
                modules={[Autoplay]}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                loop={true}
                spaceBetween={0}
                slidesPerView={1}
                className="banner2-slider"
            >
                {slides.map((slide) => (
                    <SwiperSlide key={slide.id}>
                        <div
                            className="banner-wrapper"
                            style={{
                                backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${slide.image})`
                            }}
                        >
                            <div className="container-fluid one pl--95">
                                <div className="row g-lg-4 gy-5">
                                    <div className="col-lg-7">
                                        <div className="banner-left-content">
                                            {/*<span>Real Estate</span>*/}
                                            <h1>Unlocking Your Potential With Al-Shaar Consulting and Development.</h1>
                                            <a className="primary-btn1 btn-hover" href="service-details">
                                                Contact US
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
                                                    <path d="M10.1865 1.06237L0 11.2484L0.751627 12L10.9376 1.81347V8.85645H12V0H3.14355V1.06237H10.1865Z" />
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="col-lg-5 d-flex align-items-end">
                                        <div className="banner-right-content pl--95">
                                            <h5>
                                                The primary goal of consulting is to help individuals enhance their performance, solve specific problems, and achieve strategic goals.
                                            </h5>
                                            {slide.socialIcons ? (
                                                <ul className="btn-group social-area">
                                                    <li><a href="https://www.facebook.com/"><i className="bx bxl-facebook"></i></a></li>
                                                    <li><a href="https://www.linkedin.com/"><i className="bx bxl-linkedin"></i></a></li>
                                                    <li><a href="https://www.instagram.com/"><i className="bx bxl-instagram-alt"></i></a></li>
                                                </ul>
                                            ) : (
                                                <ul className="btn-group">
                                                    <li className="success-rate">Success Rate <span>90%</span></li>
                                                    <li>
                                                        <a href="#">Determine Problem</a>
                                                    </li>
                                                </ul>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
export default Section1;
